exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".grid-wrapper[data-v-6f08a958]{margin-top:2em}.grid-filters[data-v-6f08a958]{margin-bottom:1em}", ""]);

// exports
